import { createFixedMultiFilterMeta } from '#/modules/commonComponents/table/columnFilterMeta';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatFmsAmount } from '#/modules/finMgmt/shared/helper/fmsAmount';
import {
  formatVoucherTypeLabel,
  VOUCHER_TYPE_OPTIONS,
} from '#/modules/finMgmt/vouchers/helper/voucherStatus';
import { formatDateOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

/** 請款單「選擇憑證」dialog 欄位（狀態固定 ACTIVE，不顯示狀態欄） */
export function buildVoucherPickerColumns({ filters = {}, onFilterChange } = {}) {
  return [
    {
      id: 'voucherNo',
      header: '憑證號碼',
      accessorKey: 'voucherNo',
      accessorFn: (row) => displayDash(row.voucherNo),
      size: 160,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => <TruncatedTextWithTooltip text={displayDash(row.original.voucherNo)} />,
    },
    {
      id: 'voucherType',
      header: '類型',
      accessorKey: 'voucherType',
      accessorFn: (row) => formatVoucherTypeLabel(row.voucherType),
      size: 100,
      enableColumnFilter: true,
      meta: {
        ...createFixedMultiFilterMeta({
          key: 'voucherType',
          label: '類型',
          options: VOUCHER_TYPE_OPTIONS,
          filterValue: filters.voucherType,
          onChange: (value) => onFilterChange('voucherType', value),
        }),
      },
      cell: ({ row }) => formatVoucherTypeLabel(row.original.voucherType),
    },
    {
      id: 'voucherDate',
      header: '憑證日期',
      accessorKey: 'voucherDate',
      accessorFn: (row) => formatDateOrDash(row.voucherDate),
      size: 120,
    },
    {
      id: 'totalAmount',
      header: '總額',
      accessorKey: 'totalAmount',
      accessorFn: (row) => formatFmsAmount(row.totalAmount),
      size: 120,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'remark',
      header: '備註',
      accessorFn: (row) => displayDash(row.remark),
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => <TruncatedTextWithTooltip text={displayDash(row.original.remark)} />,
    },
  ];
}

/** 列表列 → 已選憑證摘要（請款單頁面顯示用） */
export function toVoucherSummary(row) {
  return {
    id: String(row.id),
    voucherNo: row.voucherNo ?? '',
    voucherType: row.voucherType ?? '',
    voucherDate: row.voucherDate ?? null,
    totalAmount: row.totalAmount ?? null,
  };
}
